import { render, staticRenderFns } from "./SalidasUpdate.vue?vue&type=template&id=1277024f&"
import script from "./SalidasUpdate.vue?vue&type=script&lang=js&"
export * from "./SalidasUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports